import { Box, Typography } from "@mui/material"
import QuizOnboarding from "./QuizOnboarding/QuizOnboarding"
import StoryOnboarding from "./StoryOnboarding/StoryOnboarding"
import SurveyOnboarding from "./SurveyOnboarding/SurveyOnboarding"
import VideoOnboarding from "./VideoOnboarding/VideoOnboarding"
import VideoImage from '../../assets/Home/Overview/Video.png';
import StoryImage from '../../assets/Home/Overview/Story.png';
import QuizImage from '../../assets/Home/Overview/Quizzeln.png';
import SurveyImage from '../../assets/Home/Overview/Survey.png';
import { useTranslation } from "react-i18next"


export const videoDict = 
    {
        info: 
        <VideoText/>,
        interaction: <VideoOnboarding/>,
        id: "video",
        image: VideoImage,
    }
export const comicsDict = 
    {
        info: <ComicsText/>,
        interaction: <StoryOnboarding />,
        id: "story",
        image: StoryImage,
    }
export const quizDict =
    {
        info: <QuizText/>,
        interaction: <QuizOnboarding/>,
        id: "quiz",
        image: QuizImage,
    }
export const SurveyDict = 
    {
        info: <SurveyText/>,
        title: "Umfrage",
        interaction: <SurveyOnboarding/>,
        id: "survey",
        image: SurveyImage,
    }

function VideoText() {

    const {t} = useTranslation()

    return(
        <Box>
            <Typography variant="h2" sx={{mb: 1}}>
                {t("welcomeVideoTitle")}
            </Typography>
            <Box sx={{pt: {xs: 1, sm: 2}}}>
                <Typography align="left" sx={{mb: 1}}>
                    {t("welcome", { website: "Gekonnt hanDeln" })}
                </Typography>
                <Typography align="left">
                    {t("welcomeVideoText1")}
                </Typography>
            </Box>
        </Box>
    )
}

function ComicsText() {
    const {t} = useTranslation()

    return(
        <Box>
        <Typography variant="h2" sx={{mb: 1}}>{t("welcomeComicsTitle")}</Typography>
        <Box sx={{pt: {xs: 1, sm: 2}}}>
            <Typography align="left" sx={{mb: 1}}>
                {t("welcome", { website: "Gekonnt hanDeln" })}
            </Typography>
            <Typography align="left">
                {t("welcomeComicsText1")}
            </Typography>
        </Box>
    </Box>
    )
}
function QuizText() {
    const {t} = useTranslation()

    return(
        <Box>
            <Typography variant="h2" sx={{mb: 1}}>
                {t("welcomeQuizTitle")}
            </Typography>            
            <Box sx={{pt: {xs: 1, sm: 2}}}>
                <Typography align="left" sx={{mb: 1}}>
                    {t("welcome", { website: "Gekonnt hanDeln" })}
                </Typography>
                <Typography align="left">
                    {t("welcomeQuizText1")}
                </Typography> 
            </Box>
        </Box>
    )
}

function SurveyText() {
    const {t} = useTranslation()

    return(
        <Box>
            <Typography variant="h2" sx={{mb: 1}}>
            {t("welcomeSurveyTitle")}
            </Typography>
            <Typography align="left" sx={{mb: 1, mt: 3}}>
                {t("welcome", { website: "Gekonnt hanDeln" })}
            </Typography>
            <Typography align="left">
                {t("welcomeSurveyText1")}
            </Typography> 
        </Box>
    )
}